module.exports = __webpack_public_path__ + "static/media/pms222.b50c71ef.jpg";